import googleMap from './google-map';

export default new function inspiration($) {
  this.init = () => {
    this.addEvents();
    this.modifyDOM();
    googleMap();
  };

  this.modifyDOM = () => {
  };

  this.addEvents = () => {
  };

  this.eventHandlers = {
  };

  this.helpers = {
  };

  return this.init;
}(jQuery);
